import { Link } from "react-router-dom";
import { Flame, ChevronRight } from "lucide-react";
import { useQuest, useLeft, endLabel } from "@/lib/quest";
import { QuestGoals } from "@/components/quest/QuestGoals";
import { DoneStamp } from "@/components/quest/DoneStamp";

function Timer({ end }) {
  const { left, text } = useLeft(end);
  return <span className="tabular-nums" data-testid="quest-feed-timer">{left > 0 ? `noch ${text}` : "beendet"}</span>;
}

export function QuestFeedCard() {
  const [q] = useQuest(60000);
  if (!q || q.excluded || q.status !== "running" || q.hide) return null;
  return (
    <Link to="/community-aufgabe" className="quest-glow block relative overflow-hidden rounded-3xl text-white p-5 space-y-3 fade-up" data-urgent={q.status === "running" && new Date(q.end) - Date.now() < 86400000 ? "2" : undefined} data-testid="quest-feed-card">
      <span className="contest-shine" />
      {q.done && <span className="absolute inset-0 z-10 grid place-items-center bg-emerald-950/25 pointer-events-none"><DoneStamp /></span>}
      <div className="relative flex items-center justify-between gap-2 text-xs font-extrabold uppercase tracking-widest">
        <span className="inline-flex items-center gap-1.5"><Flame className="w-4 h-4" /> Community-Aufgabe</span>
        {q.status === "running" ? <Timer end={q.end} /> : <span>{q.success ? "Geschafft 🎉" : q.status === "settled" ? "Verpasst" : "Wird ausgewertet"}</span>}
      </div>
      <p className="relative font-display text-xl font-extrabold leading-snug">{q.done ? `Geschafft! Die Community hat alle Ziele erreicht – jeder Mitmacher bekommt ${q.stake} Punkte. 🎉` : q.status === "running" ? `Nur gemeinsam schaffbar: ${q.goals.length === 1 ? "Das Ziel" : `Alle ${q.goals.length} Ziele`} bis ${endLabel(q.end)} – sonst verliert jeder Mitmacher ${q.stake} Punkte!` : q.success ? `Ihr habt es geschafft! Jeder Mitmacher bekommt ${q.stake} Punkte.` : `Leider verpasst – jeder Mitmacher verliert ${q.stake} Punkte.`}</p>
      <div className="relative"><QuestGoals goals={q.goals} /></div>
      <p className="relative flex items-center justify-between text-sm font-semibold">
        <span data-testid="quest-feed-participants">{q.participants} machen schon mit</span>
        <span className="inline-flex items-center gap-0.5">Ansehen <ChevronRight className="w-4 h-4" /></span>
      </p>
    </Link>
  );
}
